import { render } from "./MaatOntwikkeling.vue?vue&type=template&id=413be4f2"
const script = {}

import "./MaatOntwikkeling.vue?vue&type=style&index=0&id=413be4f2&lang=css"

import exportComponent from "/tmp/nginx/vue-single-page-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__